import * as React from "react";
import { styled } from "@mui/material";

//region [[ Styles ]]

const ContainerStyled = styled("div")<{ maxWidth?: number | string }>(
  ({ theme, maxWidth }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
    background: "#FFFFFF",
    boxShadow: "0px 0px 35px rgba(0, 0, 0, 0.1)",
    borderRadius: 8,
    padding: "30px 40px",
    margin: "auto",
    maxWidth: maxWidth || 630,
    fontSize: 14,
    lineHeight: 1.5,
    position: "relative",
    "& .submit-button": {
      marginTop: theme.spacing(2),
    },
    [theme.breakpoints.down("sm")]: {
      padding: 24,
    },
    fontFamily: '"Inter", -apple-system, "Segoe UI", sans-serif',
    color: "rgba(0, 0, 0, 0.87)",
    "& #patientSummary": {
      fontFamily: '"Inter", -apple-system, "Segoe UI", sans-serif',
      color: "rgba(0, 0, 0, 0.87)",
      fontSize: 14,
      lineHeight: 1.5,
    },
  }),
);

const FormTitle = styled("h1")(({ theme }) => ({
  color: theme.palette.primary.main,
  margin: 0,
  fontSize: 24,
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ContainerProps {
  children: React.ReactNode;
  title?: string;
  style?: React.CSSProperties;
  className?: string;
  maxWidth?: number | string;
  rtlDisplay?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const Container = ({
  children,
  title,
  style,
  className,
  maxWidth,
  rtlDisplay,
}: ContainerProps) => {
  return (
    <ContainerStyled
      style={style}
      maxWidth={maxWidth}
      className={"rag-container " + className}
      dir={rtlDisplay ? "rtl" : "ltr"}
    >
      {title && <FormTitle>{title}</FormTitle>}
      {children}
    </ContainerStyled>
  );
};
